<template>
    <login>
        <form>
        <div class="auth-text">
            <h3>به هنزاگلد خوش آمدید</h3>
            <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</p> -->
        </div>
        <!--start send phone -->
        <div v-if="!Token_Flag">
            <div class="form-group">
                <input name="Phone" @keyup.enter.once.prevent="Send_Phone"
                    @blur="Blur"
                    v-model="Phone"
                    type="text" class="form-control form-control-light" placeholder="شماره تلفن">
            </div>
            <span v-if="Alert"
            class="text-danger text-sm" style="margin-right: .5rem;">
                {{Alert}}
            </span>
            <button @click.prevent="Send_Phone"
                class="btn-custom secondary btn-block">ارسال</button>
            <div class="auth-seperator">
                <span></span>
            </div>
        </div>
        <!--end send phone -->
        <!--start send token -->
        <div v-if="Token_Flag">
            <div class="form-group">
                <input name="token" @keyup.enter.once.prevent="Send_Token"
                    id="one-time-code"
                    v-model="Token"
                    type="text" class="form-control form-control-light" placeholder="کد ارسال شده">
            </div>
            <div class="text-center">
                <a @click="Change_Phone" href="#">تغییر شماره همراه</a>
                &nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
                <div v-if="Timer>0" style="display: inline;" class="toltip">
                    <span class="toltiptext">لطفا تا اتمام تایمر صبر کنید</span>
                   ارسال مجدد کد تایید
                </div>
                <a @click.prevent="Send_Phone" v-else href="#">ارسال مجدد کد تایید</a>
                <p class="center">( 00:{{Timer}} )</p>
            </div>
            <button @click.prevent="Send_Token"
                class="btn-custom secondary btn-block">ورود</button>
            <div class="auth-seperator">
                <span></span>
            </div>
        </div>
        <!--end send token -->
        <div class="social-login">
            <a href="https://henzagold.shop/" class="btn-custom secondary btn-block">
                بازگشت به فروشگاه
            </a>
        </div>
        <p class="text-center mb-0">آیا شما ثبت نام نکرده اید ؟ <router-link to="/register" class="">ساخت حساب کاربری</router-link></p>
</form>
    </login>
</template>

<script>
import axios from '@/plugins/axios'
import login from '@/components/layouts/login'
export default {
    props:{
        togglePreLoader: Function
    },
    components: {
        login
    },
    data () {
        return {
            Phone: null,
            Token: null,
            Alert: '',
            Is_Phone_Correct: false,
            Token_Flag: false,
            Data: null,
            Timer: 0,
            Error: null,
            requestFlag: true,
        }
    },
    methods: {
        checkRoute () {
            if (this.$route.query.outerRoute) {
                window.location.href = this.$route.query.outerRoute
            }
            else if (this.$route.query.innerRoute){
                this.$router.push(`/${this.$route.query.innerRoute}`)
            }
            else{
                this.$router.push("/my-orders")
            }
        },
        Change_Phone () {
            this.Token_Flag = !this.Token_Flag
            this.Phone = null
        },
        async Send_Token () {
            try {
                if (this.Token && this.requestFlag){
                    this.requestFlag = false
                    this.togglePreLoader('open')
                    let {data}= await axios ({
                    method: 'post',
                    url:`/cu/verfiy/token`,
                    headers: {},
                    data: {
                    id: this.Data['id'],
                    token: this.Token,
                    }
                    })
                    this.Data = data
                    this.Token_Flag = true
                    localStorage.setItem('accessToken' ,data['api_token'])
                    localStorage.setItem('userInfo' ,JSON.stringify(data))
                    this.checkRoute()
                }
            } catch (error) {
              if (error.response && error.response.data.errors) {
                let str_error = ''
                for(let item of Object.values(error.response.data.errors))
                {
                  item.map(xx=>{
                    if (xx.includes("shipping address")){
                      str_error += xx.replace("shipping address","آدرس") + "<br/>"
                    }
                    else{
                      str_error += xx + "<br/>"
                    }
                  })
                }
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
              }
              else{
                if (error) {
                  if(error == "Error: Network Error"){
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                  }
                  else {
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"کد تایید وارد شده اشتباه است",color:'var(--secondary-color)',icon:'error_outline'})
                  }
                }
              }
            } finally {
                this.togglePreLoader('close')
                this.requestFlag = true
            }
        },
        async Send_Phone () {
            try {
                if (this.requestFlag &&  (this.Is_Phone_Correct || /^(\+98|0098|98|0)?9\d{9}$/g.test(this.Phone))){
                    this.requestFlag = false
                    this.togglePreLoader('open')
                    let {data}= await axios({
                        method: 'post',
                        url: `/cu/login`,
                        headers: { useCredentails: true },
                        data: {
                            phone: this.Phone
                        }
                    })
                    this.Data = data
                    this.Token_Flag = true
                    this.Timer = 60
                    this.countDownTimer()
                    this.Otp_Checker()
                } else {
                    this.$vs.notify({time:3500,text:'شماره تلفن همراه را وارد نمایید',color:'var(--secondary-color)',icon:'error_outline'})
                }
            }
            catch (error) {
                if (error.response && error.response.data.errors) {
                  let str_error = ''
                  for(let item of Object.values(error.response.data.errors))
                  {
                    item.map(xx=>{
                      if (xx.includes("shipping address")){
                        str_error += xx.replace("shipping address","آدرس") + "<br/>"
                      }
                      else{
                        str_error += xx + "<br/>"
                      }
                    })
                  }
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
                }
                else{
                  if (error) {
                    if(error == "Error: Network Error"){
                      this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                    }
                    else {
                      this.$vs.notify({title:'خطایی رخ داد',time:3500,text:'ثبت نام نکرده اید . لطفا ثبت نام کنید',color:'var(--secondary-color)',icon:'error_outline'})
                    }
                  }
                }
            }
            finally {
                this.requestFlag = true
                this.togglePreLoader('close')
            }
        },
        Otp_Checker () {
            if ('OTPCredential' in window) {
                window.addEventListener('DOMContentLoaded',this.getOtp())
            }
        },
        Blur () {
            const Pattern = /^(\+98|0098|98|0)?9\d{9}$/g
            if (this.Phone){
                if (Pattern.test(this.Phone)!== true) {
                    this.Alert = 'تلفن همراه وارد شده نامعتبر می باشد'
                    this.Is_Phone_Correct = false
                }
                else{
                    this.Is_Phone_Correct = true
                    this.Alert = ''
                }
            }
            else {
                this.Alert = 'وارد کردن تلفن همراه الزامی است'
                this.Is_Phone_Correct = false
            }
        },
        countDownTimer() {
            if(this.Timer > 0) {
                setTimeout(() => {
                    if(this.Timer>0){
                        this.Timer -= 1
                        this.countDownTimer()
                    }
                }, 1000)
            }
        },
        getOtp(){
            const input = document.querySelector('#one-time-code')
            if (!input) return;
            const ac = new AbortController();
            const form = input.closest('form');
            if (form) {
                form.addEventListener('submit',function ()  {
                    ac.abort();
                });
            }
            navigator.credentials.get({
                otp: { transport:['sms'] },
                signal: ac.signal
            }).then(otp => {
                input.value = otp.code;
                if (form) this.Send_Token();
            }).catch(err => {
                console.log(err);
            });
        }
    },
    beforeDestroy() {
        window.removeEventListener("DOMContentLoaded",this.getOtp());
    },
}
</script>
